/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * One answer as it was given. kind "note": a note question's answer.
 */
export type FormAnswerItem = {
  label: string;
  value: string;
  previous?: string | null;
  result: FormAnswerItem.result;
  kind?: string | null;
  source?: FormAnswerItem.source;
  kept_values?: Array<string> | null;
  new_values?: Array<string> | null;
};

export namespace FormAnswerItem {
  export enum result {
    ADDED = "added",
    CHANGED = "changed",
    CONFIRMED = "confirmed",
  }

  export enum source {
    ANSWER = "answer",
    FORM = "form",
  }
}
